import "core-js/modules/es6.array.some";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _classCallCheck from "/codebuild/output/src4118146767/src/www-public/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4118146767/src/www-public/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isShadowRoot, isNativeShadowDom, getInputType, maskInputValue, ignoreAttribute, transformAttribute, toLowerCase, needMaskingText, IGNORED_NODE, serializeNodeWithId } from '../../../rrweb-snapshot/es/rrweb-snapshot.js';
import { isIgnored, isBlocked, isSerialized, isAncestorRemoved, closestElementOfNode, hasShadowRoot, inDom, getShadowHost, isSerializedIframe, isSerializedStylesheet } from '../utils.js';

function isNodeInLinkedList(n) {
  return '__ln' in n;
}

var DoubleLinkedList = /*#__PURE__*/function () {
  function DoubleLinkedList() {
    _classCallCheck(this, DoubleLinkedList);

    this.length = 0;
    this.head = null;
    this.tail = null;
  }

  _createClass(DoubleLinkedList, [{
    key: "get",
    value: function get(position) {
      if (position >= this.length) {
        throw new Error('Position outside of list range');
      }

      var current = this.head;

      for (var index = 0; index < position; index++) {
        current = (current === null || current === void 0 ? void 0 : current.next) || null;
      }

      return current;
    }
  }, {
    key: "addNode",
    value: function addNode(n) {
      var node = {
        value: n,
        previous: null,
        next: null
      };
      n.__ln = node;

      if (n.previousSibling && isNodeInLinkedList(n.previousSibling)) {
        var current = n.previousSibling.__ln.next;
        node.next = current;
        node.previous = n.previousSibling.__ln;
        n.previousSibling.__ln.next = node;

        if (current) {
          current.previous = node;
        }
      } else if (n.nextSibling && isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
        var _current = n.nextSibling.__ln.previous;
        node.previous = _current;
        node.next = n.nextSibling.__ln;
        n.nextSibling.__ln.previous = node;

        if (_current) {
          _current.next = node;
        }
      } else {
        if (this.head) {
          this.head.previous = node;
        }

        node.next = this.head;
        this.head = node;
      }

      if (node.next === null) {
        this.tail = node;
      }

      this.length++;
    }
  }, {
    key: "removeNode",
    value: function removeNode(n) {
      var current = n.__ln;

      if (!this.head) {
        return;
      }

      if (!current.previous) {
        this.head = current.next;

        if (this.head) {
          this.head.previous = null;
        } else {
          this.tail = null;
        }
      } else {
        current.previous.next = current.next;

        if (current.next) {
          current.next.previous = current.previous;
        } else {
          this.tail = current.previous;
        }
      }

      if (n.__ln) {
        delete n.__ln;
      }

      this.length--;
    }
  }]);

  return DoubleLinkedList;
}();

var moveKey = function moveKey(id, parentId) {
  return "".concat(id, "@").concat(parentId);
};

var MutationBuffer = /*#__PURE__*/function () {
  function MutationBuffer() {
    var _this = this;

    _classCallCheck(this, MutationBuffer);

    this.frozen = false;
    this.locked = false;
    this.texts = [];
    this.attributes = [];
    this.removes = [];
    this.mapRemoves = [];
    this.movedMap = {};
    this.addedSet = new Set();
    this.movedSet = new Set();
    this.droppedSet = new Set();

    this.processMutations = function (mutations) {
      mutations.forEach(_this.processMutation);

      _this.emit();
    };

    this.emit = function () {
      if (_this.frozen || _this.locked) {
        return;
      }

      var adds = [];
      var addedIds = new Set();
      var addList = new DoubleLinkedList();

      var getNextId = function getNextId(n) {
        var ns = n;
        var nextId = IGNORED_NODE;

        while (nextId === IGNORED_NODE) {
          ns = ns && ns.nextSibling;
          nextId = ns && _this.mirror.getId(ns);
        }

        return nextId;
      };

      var pushAdd = function pushAdd(n) {
        if (!n.parentNode || !inDom(n)) {
          return;
        }

        var parentId = isShadowRoot(n.parentNode) ? _this.mirror.getId(getShadowHost(n)) : _this.mirror.getId(n.parentNode);
        var nextId = getNextId(n);

        if (parentId === -1 || nextId === -1) {
          return addList.addNode(n);
        }

        var sn = serializeNodeWithId(n, {
          doc: _this.doc,
          mirror: _this.mirror,
          blockClass: _this.blockClass,
          blockSelector: _this.blockSelector,
          maskTextClass: _this.maskTextClass,
          maskTextSelector: _this.maskTextSelector,
          skipChild: true,
          newlyAddedElement: true,
          inlineStylesheet: _this.inlineStylesheet,
          maskInputOptions: _this.maskInputOptions,
          maskTextFn: _this.maskTextFn,
          maskInputFn: _this.maskInputFn,
          slimDOMOptions: _this.slimDOMOptions,
          dataURLOptions: _this.dataURLOptions,
          recordCanvas: _this.recordCanvas,
          inlineImages: _this.inlineImages,
          onSerialize: function onSerialize(currentN) {
            if (isSerializedIframe(currentN, _this.mirror)) {
              _this.iframeManager.addIframe(currentN);
            }

            if (isSerializedStylesheet(currentN, _this.mirror)) {
              _this.stylesheetManager.trackLinkElement(currentN);
            }

            if (hasShadowRoot(n)) {
              _this.shadowDomManager.addShadowRoot(n.shadowRoot, _this.doc);
            }
          },
          onIframeLoad: function onIframeLoad(iframe, childSn) {
            _this.iframeManager.attachIframe(iframe, childSn);

            _this.shadowDomManager.observeAttachShadow(iframe);
          },
          onStylesheetLoad: function onStylesheetLoad(link, childSn) {
            _this.stylesheetManager.attachLinkElement(link, childSn);
          }
        });

        if (sn) {
          adds.push({
            parentId: parentId,
            nextId: nextId,
            node: sn
          });
          addedIds.add(sn.id);
        }
      };

      while (_this.mapRemoves.length) {
        _this.mirror.removeNodeFromMap(_this.mapRemoves.shift());
      }

      var _iterator = _createForOfIteratorHelper(_this.movedSet),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var n = _step.value;

          if (isParentRemoved(_this.removes, n, _this.mirror) && !_this.movedSet.has(n.parentNode)) {
            continue;
          }

          pushAdd(n);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(_this.addedSet),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _n = _step2.value;

          if (!isAncestorInSet(_this.droppedSet, _n) && !isParentRemoved(_this.removes, _n, _this.mirror)) {
            pushAdd(_n);
          } else if (isAncestorInSet(_this.movedSet, _n)) {
            pushAdd(_n);
          } else {
            _this.droppedSet.add(_n);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var candidate = null;

      while (addList.length) {
        var node = null;

        if (candidate) {
          var parentId = _this.mirror.getId(candidate.value.parentNode);

          var nextId = getNextId(candidate.value);

          if (parentId !== -1 && nextId !== -1) {
            node = candidate;
          }
        }

        if (!node) {
          var tailNode = addList.tail;

          while (tailNode) {
            var _node = tailNode;
            tailNode = tailNode.previous;

            if (_node) {
              var _parentId = _this.mirror.getId(_node.value.parentNode);

              var _nextId = getNextId(_node.value);

              if (_nextId === -1) continue;else if (_parentId !== -1) {
                node = _node;
                break;
              } else {
                var unhandledNode = _node.value;

                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  var shadowHost = unhandledNode.parentNode.host;

                  var _parentId2 = _this.mirror.getId(shadowHost);

                  if (_parentId2 !== -1) {
                    node = _node;
                    break;
                  }
                }
              }
            }
          }
        }

        if (!node) {
          while (addList.head) {
            addList.removeNode(addList.head.value);
          }

          break;
        }

        candidate = node.previous;
        addList.removeNode(node.value);
        pushAdd(node.value);
      }

      var payload = {
        texts: _this.texts.map(function (text) {
          return {
            id: _this.mirror.getId(text.node),
            value: text.value
          };
        }).filter(function (text) {
          return !addedIds.has(text.id);
        }).filter(function (text) {
          return _this.mirror.has(text.id);
        }),
        attributes: _this.attributes.map(function (attribute) {
          var attributes = attribute.attributes;

          if (typeof attributes.style === 'string') {
            var diffAsStr = JSON.stringify(attribute.styleDiff);
            var unchangedAsStr = JSON.stringify(attribute._unchangedStyles);

            if (diffAsStr.length < attributes.style.length) {
              if ((diffAsStr + unchangedAsStr).split('var(').length === attributes.style.split('var(').length) {
                attributes.style = attribute.styleDiff;
              }
            }
          }

          return {
            id: _this.mirror.getId(attribute.node),
            attributes: attributes
          };
        }).filter(function (attribute) {
          return !addedIds.has(attribute.id);
        }).filter(function (attribute) {
          return _this.mirror.has(attribute.id);
        }),
        removes: _this.removes,
        adds: adds
      };

      if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) {
        return;
      }

      _this.texts = [];
      _this.attributes = [];
      _this.removes = [];
      _this.addedSet = new Set();
      _this.movedSet = new Set();
      _this.droppedSet = new Set();
      _this.movedMap = {};

      _this.mutationCb(payload);
    };

    this.processMutation = function (m) {
      if (isIgnored(m.target, _this.mirror)) {
        return;
      }

      switch (m.type) {
        case 'characterData':
          {
            var value = m.target.textContent;

            if (!isBlocked(m.target, _this.blockClass, _this.blockSelector, false) && value !== m.oldValue) {
              _this.texts.push({
                value: needMaskingText(m.target, _this.maskTextClass, _this.maskTextSelector) && value ? _this.maskTextFn ? _this.maskTextFn(value, closestElementOfNode(m.target)) : value.replace(/[\S]/g, '*') : value,
                node: m.target
              });
            }

            break;
          }

        case 'attributes':
          {
            var target = m.target;
            var attributeName = m.attributeName;

            var _value = m.target.getAttribute(attributeName);

            if (attributeName === 'value') {
              var type = getInputType(target);
              _value = maskInputValue({
                element: target,
                maskInputOptions: _this.maskInputOptions,
                tagName: target.tagName,
                type: type,
                value: _value,
                maskInputFn: _this.maskInputFn
              });
            }

            if (isBlocked(m.target, _this.blockClass, _this.blockSelector, false) || _value === m.oldValue) {
              return;
            }

            var item = _this.attributes.find(function (a) {
              return a.node === m.target;
            });

            if (target.tagName === 'IFRAME' && attributeName === 'src' && !_this.keepIframeSrcFn(_value)) {
              if (!target.contentDocument) {
                attributeName = 'rr_src';
              } else {
                return;
              }
            }

            if (!item) {
              item = {
                node: m.target,
                attributes: {},
                styleDiff: {},
                _unchangedStyles: {}
              };

              _this.attributes.push(item);
            }

            if (attributeName === 'type' && target.tagName === 'INPUT' && (m.oldValue || '').toLowerCase() === 'password') {
              target.setAttribute('data-rr-is-password', 'true');
            }

            if (!ignoreAttribute(target.tagName, attributeName)) {
              item.attributes[attributeName] = transformAttribute(_this.doc, toLowerCase(target.tagName), toLowerCase(attributeName), _value);

              if (attributeName === 'style') {
                var unattachedDoc;

                try {
                  unattachedDoc = document.implementation.createHTMLDocument();
                } catch (e) {
                  unattachedDoc = _this.doc;
                }

                var old = unattachedDoc.createElement('span');

                if (m.oldValue) {
                  old.setAttribute('style', m.oldValue);
                }

                for (var _i = 0, _Array$from = Array.from(target.style); _i < _Array$from.length; _i++) {
                  var pname = _Array$from[_i];
                  var newValue = target.style.getPropertyValue(pname);
                  var newPriority = target.style.getPropertyPriority(pname);

                  if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                    if (newPriority === '') {
                      item.styleDiff[pname] = newValue;
                    } else {
                      item.styleDiff[pname] = [newValue, newPriority];
                    }
                  } else {
                    item._unchangedStyles[pname] = [newValue, newPriority];
                  }
                }

                for (var _i2 = 0, _Array$from2 = Array.from(old.style); _i2 < _Array$from2.length; _i2++) {
                  var _pname = _Array$from2[_i2];

                  if (target.style.getPropertyValue(_pname) === '') {
                    item.styleDiff[_pname] = false;
                  }
                }
              }
            }

            break;
          }

        case 'childList':
          {
            if (isBlocked(m.target, _this.blockClass, _this.blockSelector, true)) return;
            m.addedNodes.forEach(function (n) {
              return _this.genAdds(n, m.target);
            });
            m.removedNodes.forEach(function (n) {
              var nodeId = _this.mirror.getId(n);

              var parentId = isShadowRoot(m.target) ? _this.mirror.getId(m.target.host) : _this.mirror.getId(m.target);

              if (isBlocked(m.target, _this.blockClass, _this.blockSelector, false) || isIgnored(n, _this.mirror) || !isSerialized(n, _this.mirror)) {
                return;
              }

              if (_this.addedSet.has(n)) {
                deepDelete(_this.addedSet, n);

                _this.droppedSet.add(n);
              } else if (_this.addedSet.has(m.target) && nodeId === -1) ;else if (isAncestorRemoved(m.target, _this.mirror)) ;else if (_this.movedSet.has(n) && _this.movedMap[moveKey(nodeId, parentId)]) {
                deepDelete(_this.movedSet, n);
              } else {
                _this.removes.push({
                  parentId: parentId,
                  id: nodeId,
                  isShadow: isShadowRoot(m.target) && isNativeShadowDom(m.target) ? true : undefined
                });
              }

              _this.mapRemoves.push(n);
            });
            break;
          }
      }
    };

    this.genAdds = function (n, target) {
      if (_this.processedNodeManager.inOtherBuffer(n, _this)) return;
      if (_this.addedSet.has(n) || _this.movedSet.has(n)) return;

      if (_this.mirror.hasNode(n)) {
        if (isIgnored(n, _this.mirror)) {
          return;
        }

        _this.movedSet.add(n);

        var targetId = null;

        if (target && _this.mirror.hasNode(target)) {
          targetId = _this.mirror.getId(target);
        }

        if (targetId && targetId !== -1) {
          _this.movedMap[moveKey(_this.mirror.getId(n), targetId)] = true;
        }
      } else {
        _this.addedSet.add(n);

        _this.droppedSet["delete"](n);
      }

      if (!isBlocked(n, _this.blockClass, _this.blockSelector, false)) {
        n.childNodes.forEach(function (childN) {
          return _this.genAdds(childN);
        });

        if (hasShadowRoot(n)) {
          n.shadowRoot.childNodes.forEach(function (childN) {
            _this.processedNodeManager.add(childN, _this);

            _this.genAdds(childN, n);
          });
        }
      }
    };
  }

  _createClass(MutationBuffer, [{
    key: "init",
    value: function init(options) {
      var _this2 = this;

      ['mutationCb', 'blockClass', 'blockSelector', 'maskTextClass', 'maskTextSelector', 'inlineStylesheet', 'maskInputOptions', 'maskTextFn', 'maskInputFn', 'keepIframeSrcFn', 'recordCanvas', 'inlineImages', 'slimDOMOptions', 'dataURLOptions', 'doc', 'mirror', 'iframeManager', 'stylesheetManager', 'shadowDomManager', 'canvasManager', 'processedNodeManager'].forEach(function (key) {
        _this2[key] = options[key];
      });
    }
  }, {
    key: "freeze",
    value: function freeze() {
      this.frozen = true;
      this.canvasManager.freeze();
    }
  }, {
    key: "unfreeze",
    value: function unfreeze() {
      this.frozen = false;
      this.canvasManager.unfreeze();
      this.emit();
    }
  }, {
    key: "isFrozen",
    value: function isFrozen() {
      return this.frozen;
    }
  }, {
    key: "lock",
    value: function lock() {
      this.locked = true;
      this.canvasManager.lock();
    }
  }, {
    key: "unlock",
    value: function unlock() {
      this.locked = false;
      this.canvasManager.unlock();
      this.emit();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.shadowDomManager.reset();
      this.canvasManager.reset();
    }
  }]);

  return MutationBuffer;
}();

function deepDelete(addsSet, n) {
  addsSet["delete"](n);
  n.childNodes.forEach(function (childN) {
    return deepDelete(addsSet, childN);
  });
}

function isParentRemoved(removes, n, mirror) {
  if (removes.length === 0) return false;
  return _isParentRemoved(removes, n, mirror);
}

function _isParentRemoved(removes, n, mirror) {
  var parentNode = n.parentNode;

  if (!parentNode) {
    return false;
  }

  var parentId = mirror.getId(parentNode);

  if (removes.some(function (r) {
    return r.id === parentId;
  })) {
    return true;
  }

  return _isParentRemoved(removes, parentNode, mirror);
}

function isAncestorInSet(set, n) {
  if (set.size === 0) return false;
  return _isAncestorInSet(set, n);
}

function _isAncestorInSet(set, n) {
  var parentNode = n.parentNode;

  if (!parentNode) {
    return false;
  }

  if (set.has(parentNode)) {
    return true;
  }

  return _isAncestorInSet(set, parentNode);
}

export { MutationBuffer as default };